import { createAction } from 'typesafe-actions';
import { Configuration } from '../../../models/config.models';

export const appInit = createAction('APP_INIT')();
export const appInitComplete = createAction('APP_INIT:COMPLETE')();

export const configurationInit = createAction('CONFIGURATION_INIT')<Configuration>();
